/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import React, { FC, useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { PersonalData, PrefijoPais } from '../../../types/PersonalData';
import { MisDatosHelper } from '../MisDatosHelper';
import IconBack from '../../../Icons/IconBack';
import { useMisDatosStore } from '../context/MisDatos.context';
import { MisDatosConstants } from '../../../utils/MisDatosConstants';
import DataService from '../../../services/MisDatosService';
import IconChat from '../../../Icons/IconChat';
import { CryptoUtil } from '../../../utils/CryptoUtil';
import ModalConfirmacion from '../../../components/ModalConfirmacion';
import useAPIError from '../../../hooks/useAPIError';
import { StorageHelper } from '../../../utils/StorageHelper';
import { HostProvider } from '../../../utils/HostProvider';
import {
  getFidelioCustomerRecordBlockedError,
  isFidelioCustomerRecordBlocked,
} from '../FidelioBlockedRecordError';

interface Props {
  userForm?: boolean;
  passForm?: boolean;
  setUserForm?: (userForm: boolean) => void;
  setPassForm?: (passForm: boolean) => void;
  accessEmail?: string;
  cargarData?: () => void;
  personalData: PersonalData;
}

const Telefono1Form: FC<Props> = (props) => {
  const { personalData, cargarData } = props;
  const {
    hideModaltelefono1,
    getPrefijosPaisesHabilitados,
    flagTelefono1Incorrecto,
    hideFlagTelefono1Incorrecto,
    hideModalV2P,
  } = useMisDatosStore();
  const [prefijoMovil, setPrefijoMovil] = useState<string>('');
  const [tamTelfMovil, setTamTelfMovil] = useState<number>(9);
  const [isValidPref1, setIsValidPref1] = useState(false);
  const [isValidPref2, setIsValidPref2] = useState(false);
  const [prefijoSec, setPrefijoSec] = useState<string>('');
  const [tamTelfSec, setTamTelfSec] = useState<number>(9);
  const [textForModalTelefono, setTextForModalTelefono] = useState(
    '' as string,
  );
  const [telefonoCambiado, setTelefonoCambiado] = useState<boolean>(false);
  const [mostrarTelefonoForm, setMostrarTelefonoForm] = useState(true);

  const { t } = useTranslation();

  const misDatosHelper = new MisDatosHelper();
  const { addError, addErrorBackImgPng } = useAPIError();
  const title = t('datos.personaldata.modal-email-confirmacion-title');
  const text1 = t('datos.personaldata.modal-email-confirmacion-message1');
  const text2 = t('datos.personaldata.modal-email-confirmacion-message2');
  const acceptButtonTextKey = t('entendido');
  const [aplicarStyle, setAplicarStyle] = useState(false);
  const botonSubmit = useRef<HTMLButtonElement>(null);
  const fromApp = StorageHelper.getFromApp() as string;

  const {
    formState: { errors },
    register,
    handleSubmit,
    getValues,
    setValue,
    clearErrors,
    trigger,
  } = useForm({
    mode: 'onChange',
  });

  const acceptEmailSend = () => {
    hideModaltelefono1();
  };

  const updateTelefono = () => {
    console.log('valores del formulario', getValues());
    const newData = {
      prefijoTelefono: btoa(
        CryptoUtil.encryptAes(getValues('prefijoTelefonoMovil')),
      ),
      telefono: btoa(CryptoUtil.encryptAes(getValues('paisTelefonoMovil'))),
      prefijoTelefonoSecundario: btoa(
        CryptoUtil.encryptAes(
          getValues('prefijo2Telefono') ? getValues('prefijo2Telefono') : '',
        ),
      ),
      telefonoSecundario: btoa(
        CryptoUtil.encryptAes(getValues('paisTelefonoSecundario')),
      ),
      version: null,
      fromApp: fromApp,
      tipoUsuario: personalData.tipoUsuario,
    };
    DataService.updateTelefonoComunicacion(newData)
      .then((response) => {
        if (!response.data.error) {
          if (getValues('paisTelefonoMovil') === personalData.telefono) {
            document.body.classList.remove('fix');
            hideModaltelefono1();
            clearErrors();
            StorageHelper.removeModalToUpMisDatos();
            StorageHelper.removeOpenTelefonoError();
          } else {
            setTextForModalTelefono(t(text1) + t(text2));
            setTelefonoCambiado(true);
            document.body.classList.remove('fix');
            setMostrarTelefonoForm(false);
          }
          if (typeof cargarData === 'function') {
            cargarData();
          }
        } else if (isFidelioCustomerRecordBlocked(response.data)) {
          const phone = HostProvider.isEroski()
            ? t('footer.phone')
            : t('caprabo.phone');
          addErrorBackImgPng(getFidelioCustomerRecordBlockedError(phone));
        } else {
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
        }
      })
      .catch((er: any) => {
        console.log(er);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
      });
  };
  const validarPrefijo = (isPrefijo1: boolean) => {
    const PrefijoMovilSpainDefaullt: PrefijoPais = {
      id: 1,
      pais: 'España',
      predefinido: 1,
      prefijo: '34',
      tamanioTelefono: 9,
    };
    let prefijoEncontrado: PrefijoPais = PrefijoMovilSpainDefaullt;

    const validarPrefijoComun = (prefijoTelefono: string) => {
      return getPrefijosPaisesHabilitados().some(
        (currentValue: PrefijoPais) => {
          if (currentValue.id.toString() === prefijoTelefono) {
            prefijoEncontrado = currentValue;
            return true;
          }
          return false;
        },
      );
    };

    const prefijoTelefono = isPrefijo1
      ? personalData.prefijoTelefono
      : personalData.prefijoTelefonoSecundario ?? '';

    const telefono = !isPrefijo1 && personalData.telefonoSecundario;

    const isprefijoValido = () => {
      if (isPrefijo1) {
        return prefijoTelefono ? validarPrefijoComun(prefijoTelefono) : false;
      }
      return prefijoTelefono && telefono
        ? validarPrefijoComun(prefijoTelefono)
        : false;
    };

    if (isPrefijo1) {
      setPrefijoMovil(prefijoEncontrado.prefijo);
      setTamTelfMovil(prefijoEncontrado.tamanioTelefono);
    } else {
      if (personalData.telefonoSecundario !== '') {
        setPrefijoSec('');
      } else {
        setPrefijoSec(isprefijoValido() ? prefijoEncontrado.prefijo : '34');
      }
      setTamTelfSec(prefijoEncontrado.tamanioTelefono);
    }
    return isprefijoValido();
  };
  const prepararCamposDeTelefonosInformados = () => {
    const isprefijo1Valido = validarPrefijo(true);
    const isprefijo2Valido = validarPrefijo(false);
    setIsValidPref1(isprefijo1Valido);
    setIsValidPref2(isprefijo2Valido);
  };

  useEffect(() => {
    hideModalV2P();
    prepararCamposDeTelefonosInformados();
    setAplicarStyle(true);
    return () => {
      document.body.classList.remove('fix');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personalData, hideModalV2P]);

  useEffect(() => {
    const errorOro = StorageHelper.getOpenTelefonoError();
    const modalToUp = StorageHelper.getModalToUpMisDatos();
    const debeValidar =
      (flagTelefono1Incorrecto || (errorOro !== null && errorOro === 'true')) &&
      modalToUp !== null;

    if (debeValidar && personalData.telefono) {
      hideFlagTelefono1Incorrecto();
      StorageHelper.removeOpenTelefonoError();
      StorageHelper.removeModalToUpMisDatos();
      setValue('prefijoTelefonoMovil', personalData.prefijoTelefono || '1');
      setValue('paisTelefonoMovil', personalData.telefono || '');
      setValue(
        'prefijo2Telefono',
        personalData.prefijoTelefonoSecundario || '',
      );
      setValue('paisTelefonoSecundario', personalData.telefonoSecundario || '');
      trigger();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personalData.telefono]);

  useEffect(() => {
    trigger(); // fuerza validación de todos los campos
  }, [personalData, trigger]);

  const cambiarStyle = () => {
    setAplicarStyle(false);
    clearErrors();
    StorageHelper.removeModalToUpMisDatos();
    setTimeout(() => {
      hideModaltelefono1();
    }, 300);
  };

  return (
    <>
      {mostrarTelefonoForm ? (
        <>
          <section
            id="section-email"
            className={`o-section--large form-telefono
                 bloque-form ${aplicarStyle ? 'visible' : ''}`}
          >
            <div className="container">
              <a
                id="acceso-back"
                href="#telefono"
                onClick={() => {
                  cambiarStyle();
                }}
                className="link-prev"
              >
                <div className="icon icon-medium">
                  <IconBack />
                </div>
                <p className="u-font-normal u-text-brand u-margin-left">
                  {t('datos.accessdata.back')}{' '}
                </p>
              </a>
              <form
                id="form-telefono-contact"
                className="form-datos-list"
                onSubmit={handleSubmit(updateTelefono)}
              >
                <fieldset>
                  <h2 className="bloque-datos__title u-text-brand">
                    <span className="divider__square brand-color" />
                    <span className="u-margin-right">
                      {t('datos.contactData.label-actual-telefono1-title')}{' '}
                    </span>
                  </h2>
                  <div className="row u-margin-bottom">
                    <div className="col-12 col-md-4">
                      <div className="form-group select-wrapper u-margin-bottom">
                        <label
                          htmlFor="pais-telefono"
                          className="control-label"
                        >
                          {t('datos.personaldata.movil')}
                        </label>
                        <div className="u-display-flex">
                          <div className="form-control-block form-control--compound">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label className="hidden" htmlFor="pais-telefono">
                              Selecciona el prefijo
                            </label>
                            <select
                              id="pais-telefono"
                              className={`form-control pais-telefono ${
                                errors.prefijoTelefonoMovil ? 'error' : ''
                              }`}
                              {...register('prefijoTelefonoMovil', {
                                required: true,
                                onChange: (element) => {
                                  const prefijoEncontrado = misDatosHelper.formatearEspecificacionesDelInputTelefono1(
                                    getPrefijosPaisesHabilitados(),
                                    element.target.value,
                                  );
                                  console.log(prefijoEncontrado);
                                },
                              })}
                            >
                              {!isValidPref1 && (
                                <option value="" selected>
                                  {' '}
                                </option>
                              )}
                              {getPrefijosPaisesHabilitados().length > 0 ? (
                                getPrefijosPaisesHabilitados().map((c) =>
                                  misDatosHelper.logicaPrefijos(
                                    c,
                                    personalData,
                                  ) ? (
                                    <option
                                      selected={
                                        personalData.telefono === ''
                                          ? c.id ===
                                            MisDatosConstants.FLAG_NUMBER_ACTIVO
                                          : c.id ===
                                            Number(personalData.prefijoTelefono)
                                      }
                                      value={c.id}
                                      key={c.id}
                                    >
                                      {c.prefijo}
                                    </option>
                                  ) : (
                                    <>
                                      {!isValidPref1 && (
                                        <option value="" selected>
                                          {' '}
                                        </option>
                                      )}
                                      <option
                                        value={Number('1')}
                                        key={Number('1')}
                                      >
                                        34
                                      </option>
                                    </>
                                  ),
                                )
                              ) : (
                                <>
                                  <option value="" selected>
                                    {' '}
                                  </option>
                                  <option value={Number('1')} key={Number('1')}>
                                    34
                                  </option>
                                </>
                              )}
                            </select>
                            <div className="icon icon-small">
                              <IconChat />
                            </div>
                          </div>
                          <input
                            type="text"
                            className={`form-control u-margin-left ${
                              !errors.prefijoTelefonoMovil &&
                              errors.paisTelefonoMovil
                                ? 'error'
                                : ''
                            }`}
                            id="pais-telefono-movil"
                            maxLength={tamTelfMovil}
                            defaultValue={personalData.telefono}
                            {...register('paisTelefonoMovil', {
                              required: true,
                              validate: (value) => {
                                if (!errors?.prefijoTelefonoMovil) {
                                  return misDatosHelper.testTelefono(
                                    `pais-telefono`,
                                    value,
                                  );
                                }
                                return true;
                              },
                            })}
                          />
                        </div>
                        <>
                          {errors.prefijoTelefonoMovil &&
                            errors.prefijoTelefonoMovil.type === 'required' && (
                              // eslint-disable-next-line jsx-a11y/label-has-associated-control
                              <label
                                id="paisTelefonoMovil-error"
                                className="error"
                                htmlFor="paisTelefonoMovil"
                              >
                                Campo obligatorio
                              </label>
                            )}
                          {!errors.prefijoTelefonoMovil &&
                            errors.paisTelefonoMovil &&
                            errors.paisTelefonoMovil.type === 'required' && (
                              // eslint-disable-next-line jsx-a11y/label-has-associated-control
                              <label
                                id="paisTelefonoMovil-error"
                                className="error"
                                htmlFor="paisTelefonoMovil"
                              >
                                {t('validaciones.empty-value')}
                              </label>
                            )}
                          {!errors.prefijoTelefonoMovil &&
                            errors.paisTelefonoMovil &&
                            errors.paisTelefonoMovil.type === 'validate' && (
                              // eslint-disable-next-line jsx-a11y/label-has-associated-control
                              <label
                                id="paisTelefonoMovil-error"
                                className="error"
                                htmlFor="paisTelefonoMovil"
                              >
                                {t(
                                  misDatosHelper.prefixErrorValidation(
                                    prefijoMovil,
                                  ),
                                )}
                              </label>
                            )}
                        </>
                      </div>
                    </div>
                    <div className="col-12 col-md-4">
                      <div className="form-group select-wrapper u-margin-bottom">
                        <label
                          htmlFor="pais-telefono-sec"
                          className="control-label"
                        >
                          {t('datos.personaldata.phone2')}
                        </label>
                        <div className="u-display-flex">
                          <div className="form-control-block form-control--compound">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              className="hidden"
                              htmlFor="pais-telefono-sec"
                            >
                              Selecciona el prefijo
                            </label>
                            <select
                              id="pais-telefono-sec"
                              className={`form-control pais-telefono ${
                                errors.prefijo2Telefono ? 'error' : ''
                              }`}
                              {...register('prefijo2Telefono', {
                                validate: (value) => {
                                  const telefono = getValues(
                                    'paisTelefonoSecundario',
                                  );

                                  return !telefono?.trim() || value?.trim()
                                    ? true
                                    : 'Campo obligatorio';
                                },
                                onChange: (element) => {
                                  const prefijoEncontrado = misDatosHelper.formatearEspecificacionesDelInputTelefono1(
                                    getPrefijosPaisesHabilitados(),
                                    element.target.value,
                                  );
                                  console.log(prefijoEncontrado);
                                },
                              })}
                            >
                              {!isValidPref2 && (
                                <option value="" selected>
                                  {' '}
                                </option>
                              )}
                              {personalData.telefonoSecundario ? (
                                getPrefijosPaisesHabilitados().map((c) =>
                                  misDatosHelper.logicaPrefijos(
                                    c,
                                    personalData,
                                  ) ? (
                                    <option
                                      selected={
                                        personalData.telefonoSecundario === ''
                                          ? c.id ===
                                            MisDatosConstants.FLAG_NUMBER_ACTIVO
                                          : c.id ===
                                            Number(
                                              personalData.prefijoTelefonoSecundario,
                                            )
                                      }
                                      value={c.id}
                                      key={c.id}
                                    >
                                      {c.prefijo}
                                    </option>
                                  ) : (
                                    <option
                                      value={Number('1')}
                                      key={Number('1')}
                                    >
                                      34
                                    </option>
                                  ),
                                )
                              ) : (
                                <option value={Number('1')} key={Number('1')}>
                                  34
                                </option>
                              )}
                            </select>
                            <div className="icon icon-small">
                              <IconChat />
                            </div>
                          </div>
                          <input
                            type="text"
                            className={`form-control u-margin-left ${
                              errors.paisTelefonoSecundario &&
                              !errors.prefijo2Telefono
                                ? 'error'
                                : ''
                            }`}
                            id="pais-telefono-secundario"
                            maxLength={tamTelfSec}
                            defaultValue={personalData.telefonoSecundario}
                            {...register('paisTelefonoSecundario', {
                              validate: (value) =>
                                value === '' ||
                                misDatosHelper.testTelefonoCarga(
                                  `pais-telefono-sec`,
                                  value,
                                  personalData,
                                  true,
                                ) ||
                                personalData.prefijoTelefonoSecundario === null,
                            })}
                          />
                        </div>
                        {errors.prefijo2Telefono && (
                          <label
                            id="paisTelefonoSecundario-error"
                            className="error"
                            htmlFor="paisTelefonoSecundario"
                          >
                            {errors.prefijo2Telefono.message ||
                              'Campo obligatorio.'}
                          </label>
                        )}
                        {!errors.prefijo2Telefono &&
                          errors.paisTelefonoSecundario &&
                          errors.paisTelefonoSecundario.type === 'validate' && (
                            // eslint-disable-next-line jsx-a11y/label-has-associated-control
                            <label
                              id="paisTelefonoSecundario-error"
                              className="error"
                              htmlFor="paisTelefonoSecundario"
                            >
                              {t(
                                misDatosHelper.prefixErrorValidation(
                                  prefijoSec,
                                  true,
                                ),
                              )}
                            </label>
                          )}
                      </div>
                    </div>
                  </div>
                </fieldset>
                <div className="u-text-right">
                  <button
                    id="datos-telefono-submit-btn"
                    type="submit"
                    className="btn btn-primary "
                    ref={botonSubmit}
                  >
                    {t('datos.accessdata.update')}
                  </button>
                </div>
              </form>
            </div>
          </section>
        </>
      ) : null}

      <ModalConfirmacion
        isBig={false}
        isSmall={false}
        textCentered
        showModal={telefonoCambiado}
        setShowModal={setTelefonoCambiado}
        title={t(title)}
        textHTMLContent={textForModalTelefono}
        doClose={acceptEmailSend}
        doAceptar={cambiarStyle}
        showCancel={false}
        acceptButtonTextKey={acceptButtonTextKey}
      />
    </>
  );
};

export default Telefono1Form;
